document.querySelectorAll('.aos-container').forEach(container => {
    let scrollAmount = 0;

    const scrollContainer = container.querySelector('.aos-overflow');
    const btnLeft = container.querySelector('.aos-button-prev');
    const btnRight = container.querySelector('.aos-button-next');

    function checkButtonStatus() {
        
        const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

        if (Math.ceil(scrollContainer.scrollLeft) <= 0) {
            btnLeft.classList.add('aos-button-disabled');
        } else {
            btnLeft.classList.remove('aos-button-disabled');
        }

        if (Math.ceil(scrollContainer.scrollLeft) >= maxScrollLeft) {
            btnRight.classList.add('aos-button-disabled');
        } else {
            btnRight.classList.remove('aos-button-disabled');
        }
    }

    scrollContainer.addEventListener('scroll', () => {
        checkButtonStatus();
    });

    btnLeft.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        checkButtonStatus();
    });

    btnRight.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        checkButtonStatus();
    });

    function updateButtonPosition() {
        const firstCard = scrollContainer.querySelector(':scope .grid__item');
        if (firstCard) {
            const style = getComputedStyle(firstCard);
            const marginLeft = parseFloat(style.marginLeft);
            const marginRight = parseFloat(style.marginRight);
            const cardWidth = firstCard.offsetWidth + marginLeft + marginRight;
        
            const halfWidth = cardWidth / 2;
        
            const containerWidth = scrollContainer.offsetWidth;
            scrollAmount = containerWidth * 0.466;
            
            btnLeft.style.top = `${halfWidth}px`;
            btnRight.style.top = `${halfWidth}px`;
        }

        checkButtonStatus();
    }

    setTimeout(updateButtonPosition, 300);

    window.addEventListener('resize', () => {
        updateButtonPosition();
    });

    checkButtonStatus();
});
